import { useRef, useEffect, RefObject, type MutableRefObject } from 'react'
import L, { Map, MapOptions, Layer } from 'leaflet'
import { DEFAULT_MAP_OPTIONS } from '../LeafletMap'

const useMap = (
  options: MapOptions,
  setInstance?: (map: Map) => void,
): [RefObject<HTMLDivElement>, RefObject<L.Map | null>, MutableRefObject<Layer[]>] => {
  const containerRef = useRef<HTMLDivElement>(null)
  const mapRef = useRef<L.Map | null>(null)
  const drawnRef = useRef<Layer[]>([])

  useEffect(() => {
    if (containerRef.current === null) {
      return undefined
    }

    mapRef.current = new L.Map(containerRef.current, {
      ...DEFAULT_MAP_OPTIONS,
      ...options,
    })
    drawnRef.current = []

    mapRef.current.zoomControl?.setPosition('bottomright')

    if (setInstance) {
      setInstance(mapRef.current)
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove()
      }
    }
  }, [])

  return [containerRef, mapRef, drawnRef]
}

export default useMap
